
/**
 * Module dependencies.
 */

import { Swiper, SwiperSlide } from 'swiper/react';
import React, { ReactElement, ReactNode, forwardRef } from 'react';
import SwiperCore, {
  Autoplay,
  Controller,
  EffectFade,
  Navigation,
  Pagination,
  Scrollbar,
  SwiperOptions
} from 'swiper';

import styled, { createGlobalStyle } from 'styled-components';
import swiperStyles from 'swiper/swiper-bundle.css';

/**
 * Load swiper components.
 */

SwiperCore.use([
  Autoplay,
  Controller,
  EffectFade,
  Navigation,
  Pagination,
  Scrollbar
]);

/**
 * `Props` type.
 */

type Props = SwiperOptions & {
  children: ReactNode,
  className?: string,
  ref: any
};

/**
 * `GlobalStyle` component.
 */

const GlobalStyle = createGlobalStyle`
  ${swiperStyles}
`;

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.div`
  position: relative;

  &,
  > .swiper-container {
    height: 100%;
  }

  .swiper-slide {
    height: auto;
  }
`;

/**
 * Export `Slide` component.
 */

export const Slide = SwiperSlide;

/**
 * `Slider` component.
 */

const Slider = (props: Props, ref): ReactElement => {
  const { children, className, ...rest } = props;

  return (
    <Wrapper className={className}>
      <GlobalStyle />

      <Swiper
        ref={ref}
        {...rest}
      >
        {children}
      </Swiper>
    </Wrapper>
  );
};

/**
 * Export `Slider` component.
 */

export default forwardRef<Props, any>(Slider);
